export const SHARE_URL = 'https://dada-share.herokuapp.com';
export const SHARE_BLOG = '/sharing-link/blob?categoryId=';
export const SHARE_COLLAGE = '/sharing-collage/collage/';
export const SHARE_UPLOAD = '/sharing-collage/upload';
export const VERIFY_COLLAGE = '/sharing-collage/verify';
